import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";

export const IngredientsList = styled.div`
  padding: 20px 0 20px;
  border-top: 1px solid ${Color.greySeparator};
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      border-top: 1px solid ${ColorDark.greySeparator};
    }
  }

  p {
    font-size: 11px;
    line-height: 25px;
    ${Font.sansBold};
    color: ${Color.grey};
    text-transform: uppercase;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
  li {
    font-size: 20px;
    line-height: 33px;
    ${Font.sansLight};
    color: ${Color.black000};
    ${breakpoints.phone} {
      font-size: 19px;
      line-height: 30px;
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
`;
